import React from 'react'

const OwnProductionTraceabilityTOSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4479_47376)" />
    <g clipPath="url(#clip0_4479_47376)">
      <path
        d="M25.5344 24.252C25.5344 24.3741 25.5344 24.4352 25.5344 24.5573C25.5344 28.2825 25.5344 32.0077 25.5344 35.7329C25.5344 37.0153 26.5115 37.9924 27.7939 37.9924C32.6183 37.9924 37.5038 37.9924 42.3283 37.9924C43.6718 37.9924 44.5267 37.0764 44.5267 35.7939C44.5267 32.0687 44.5267 28.3436 44.5267 24.6184C44.5267 24.5573 44.5267 24.4352 44.5267 24.313C38.1756 24.252 31.8244 24.252 25.5344 24.252ZM39.2138 29.5039C39.2138 30.0535 38.7252 30.542 38.1756 30.542H31.8244C31.2748 30.542 30.7863 30.0535 30.7863 29.5039C30.7863 28.9542 31.2748 28.4657 31.8244 28.4657H38.1145C38.7252 28.4657 39.2138 28.9542 39.2138 29.5039Z"
        fill="white"
      />
      <path
        d="M44.3435 23.2142H25.6565C24.9847 23.2142 24.4962 22.6646 24.4962 22.0539V20.2218C24.4962 19.5501 25.0458 19.0615 25.6565 19.0615H44.3435C45.0153 19.0615 45.5038 19.6111 45.5038 20.2218V22.0539C45.5649 22.6646 45.0153 23.2142 44.3435 23.2142Z"
        fill="white"
      />
      <path
        d="M49.9618 43.3051H20.0382C19.3664 43.3051 18.8168 42.7554 18.8168 42.0837C18.8168 41.4119 19.3664 40.8623 20.0382 40.8623H49.9618C50.6336 40.8623 51.1832 41.4119 51.1832 42.0837C51.1832 42.7554 50.6336 43.3051 49.9618 43.3051Z"
        fill="white"
      />
      <path
        d="M21.9313 50.9995C23.6514 50.9995 25.0458 49.6051 25.0458 47.885C25.0458 46.1649 23.6514 44.7705 21.9313 44.7705C20.2112 44.7705 18.8168 46.1649 18.8168 47.885C18.8168 49.6051 20.2112 50.9995 21.9313 50.9995Z"
        fill="white"
      />
      <path
        d="M30.6641 50.9995C32.3842 50.9995 33.7786 49.6051 33.7786 47.885C33.7786 46.1649 32.3842 44.7705 30.6641 44.7705C28.944 44.7705 27.5496 46.1649 27.5496 47.885C27.5496 49.6051 28.944 50.9995 30.6641 50.9995Z"
        fill="white"
      />
      <path
        d="M39.3969 50.9995C41.117 50.9995 42.5114 49.6051 42.5114 47.885C42.5114 46.1649 41.117 44.7705 39.3969 44.7705C37.6769 44.7705 36.2824 46.1649 36.2824 47.885C36.2824 49.6051 37.6769 50.9995 39.3969 50.9995Z"
        fill="white"
      />
      <path
        d="M48.0687 50.9995C49.7888 50.9995 51.1832 49.6051 51.1832 47.885C51.1832 46.1649 49.7888 44.7705 48.0687 44.7705C46.3486 44.7705 44.9542 46.1649 44.9542 47.885C44.9542 49.6051 46.3486 50.9995 48.0687 50.9995Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4479_47376"
        x1="34.5455"
        y1="0"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#49912D" />
        <stop offset="1" stopColor="#33691E" />
      </linearGradient>
      <clipPath id="clip0_4479_47376">
        <rect width="32.3664" height="32" fill="white" transform="translate(18.8168 19)" />
      </clipPath>
    </defs>
  </svg>
)

export default OwnProductionTraceabilityTOSubcategory
